// The dart of a drill spot (arcade.md §17.8, R1573, mockup round 075
// card 13): one notched arrowhead that the four arrowheads around a spot
// and the edge arrow of a spot off the glass both draw.
//
// The atlas bakes it once, white and pointing along +x, at the edge
// arrow's own size (`fast/gfx/atlas.ts` `drillSpecFor`); the layer
// (`fast/layers/drillspot.ts`) tints and stretches each quad to the length
// and the width it needs. One cell serves both shapes because the card
// draws them with one notch.

import { DRILL_DART_NOTCH, DRILL_EDGE_LEN_PX, DRILL_EDGE_W_PX } from '../gen/presentation';

/** The atlas key of the dart. */
export const DRILL_DART_KEY = 'drill-dart';

/** The baked cell's length along the point and its width across it, in px
 *  at scale 1: the edge arrow's figures. */
export const DART_CELL_LEN = DRILL_EDGE_LEN_PX;
export const DART_CELL_W = DRILL_EDGE_W_PX;

/**
 * The dart's four corners around its centre: the tip, one back corner,
 * the notch and the other back corner. The notch cuts into the back edge
 * by `DRILL_DART_NOTCH` of the length.
 */
export function dartCorners(len = DART_CELL_LEN, w = DART_CELL_W): [number, number][] {
  const h = len / 2;
  return [[h, 0], [-h, w / 2], [-h + DRILL_DART_NOTCH * len, 0], [-h, -w / 2]];
}

/** Paints the dart white around the origin of `ctx`. */
export function paintDrillDart(ctx: CanvasRenderingContext2D): void {
  const pts = dartCorners();
  ctx.beginPath();
  ctx.moveTo(pts[0][0], pts[0][1]);
  for (let i = 1; i < pts.length; i++) ctx.lineTo(pts[i][0], pts[i][1]);
  ctx.closePath();
  ctx.fillStyle = '#ffffff';
  ctx.fill();
}
